/**
 * 从ua中获取app参数，用到哪个列哪个
 * @param {String} userAgent
 * @return {Object}
 */
export function getParamsFromUA(userAgent) {
  const matchArr = userAgent.match(/\/[a-z]+\((\d{4}),(android|ios)/);
  const version = (matchArr && matchArr[1]) || '';
  const os = (matchArr && matchArr[2]) || '';
  return {
    version,
    os,
    xlApp: /(xiaolachuxing|huolala)/.test(userAgent),
  };
}
